var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp-common-layout page" }, [
    _c("div", { staticClass: "jp-common-layout-left" }, [
      _c(
        "div",
        { staticClass: "jp-common-title" },
        [
          _c("el-input", {
            attrs: {
              placeholder: "组织机构:请输入关键字过滤",
              size: "small",
              clearable: "",
            },
            model: {
              value: _vm.filterText,
              callback: function ($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "jp-common-el-tree-scrollbar el-scrollbar" }, [
        _c("div", { staticClass: "el-scrollbar__wrap" }, [
          _c(
            "div",
            { staticClass: "el-scrollbar__view" },
            [
              _c("el-tree", {
                ref: "officeTree",
                staticClass: "filter-tree jp-common-el-tree",
                attrs: {
                  "render-content": _vm.renderContent,
                  data: _vm.officeTreeData,
                  props: {
                    value: "id", // ID字段名
                    label: "name", // 显示名称
                    children: "children", // 子级字段名
                  },
                  "node-key": "id",
                  "default-expand-all": "",
                  "filter-node-method": _vm.filterNode,
                  "expand-on-click-node": false,
                  "highlight-current": "",
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "jp-common-layout-center jp-flex-main" },
      [
        _c(
          "el-form",
          {
            ref: "searchForm",
            staticClass: "query-form",
            attrs: { size: "small", inline: true, model: _vm.searchForm },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.refreshList()
              },
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { prop: "loginName" } },
              [
                _c("el-input", {
                  attrs: {
                    size: "small",
                    placeholder: "登录名",
                    clearable: "",
                  },
                  model: {
                    value: _vm.searchForm.loginName,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "loginName", $$v)
                    },
                    expression: "searchForm.loginName",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "name" } },
              [
                _c("el-input", {
                  attrs: { size: "small", placeholder: "姓名", clearable: "" },
                  model: {
                    value: _vm.searchForm.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "name", $$v)
                    },
                    expression: "searchForm.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-search",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refreshList()
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", icon: "el-icon-refresh-right" },
                    on: {
                      click: function ($event) {
                        return _vm.resetSearch()
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bg-white top" },
          [
            _c("vxe-toolbar", {
              attrs: {
                refresh: { query: _vm.refreshList },
                import: "",
                export: "",
                print: "",
                resizable: "",
                custom: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _vm.hasPermission("sys:user:add")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.add()
                                },
                              },
                            },
                            [_vm._v("新建")]
                          )
                        : _vm._e(),
                      _vm.hasPermission("sys:user:edit")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "warning",
                                size: "small",
                                icon: "el-icon-edit-outline",
                                disabled:
                                  _vm.$refs.userTable &&
                                  _vm.$refs.userTable.getCheckboxRecords()
                                    .length !== 1,
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.edit()
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.hasPermission("sys:user:del")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                size: "small",
                                icon: "el-icon-delete",
                                disabled:
                                  _vm.$refs.userTable &&
                                  _vm.$refs.userTable.getCheckboxRecords()
                                    .length === 0,
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.del()
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                      _vm.hasPermission("sys:user:import")
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "default", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadTpl()
                                },
                              },
                            },
                            [_vm._v("下载模板")]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "div",
              { staticStyle: { height: "calc(100% - 80px)" } },
              [
                _c(
                  "vxe-table",
                  {
                    ref: "userTable",
                    attrs: {
                      border: "inner",
                      "auto-resize": "",
                      resizable: "",
                      height: "auto",
                      loading: _vm.loading,
                      size: "small",
                      "show-header-overflow": "",
                      "show-overflow": "",
                      "highlight-hover-row": "",
                      "print-config": {},
                      "import-config": {
                        importMethod: _vm.importMethod,
                        types: ["csv", "xls", "xlsx"],
                        remote: true,
                      },
                      "export-config": {
                        remote: true,
                        filename:
                          "用户数据" +
                          _vm.moment(new Date()).format("YYYY-MM-DD"),
                        sheetName: "用户数据",
                        exportMethod: _vm.exportMethod,
                        types: ["xlsx"],
                        modes: ["current", "selected", "all"],
                      },
                      "sort-config": { remote: true },
                      data: _vm.dataList,
                    },
                    on: { "sort-change": _vm.sortChangeHandle },
                  },
                  [
                    _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                    _c("vxe-column", {
                      attrs: { type: "checkbox", width: "40px" },
                    }),
                    _c("vxe-column", {
                      attrs: { title: "头像", field: "photo" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("img", {
                                staticStyle: { height: "35px" },
                                attrs: {
                                  src:
                                    scope.row.photo === ""
                                      ? "/static/img/avatar.png"
                                      : scope.row.photo,
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "登录名",
                        field: "loginName",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hasPermission("sys:user:edit")
                                ? _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.loginName))]
                                  )
                                : _vm.hasPermission("sys:user:view")
                                ? _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.view(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.loginName))]
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.loginName)),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: { title: "姓名", field: "name", sortable: "" },
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "公司",
                        field: "companyDTO.name",
                        "sort-by": "c.name",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-tag", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.companyDTO &&
                                      scope.row.companyDTO.name
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "部门",
                        field: "officeDTO.name",
                        "sort-by": "o.name",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-tag", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.officeDTO &&
                                      scope.row.officeDTO.name
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "状态",
                        field: "loginFlag",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.loginFlag === "1"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "success" },
                                    },
                                    [_vm._v("正常")]
                                  )
                                : scope.row.loginFlag === "0"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                    },
                                    [_vm._v("禁用")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "操作",
                        width: "200px",
                        fixed: "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hasPermission("sys:user:view")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "small",
                                        icon: "el-icon-view",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.view(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("sys:user:edit")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "small",
                                        icon: "el-icon-edit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("修改")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("sys:user:del")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "small",
                                        icon: "el-icon-delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.del(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("vxe-pager", {
                  attrs: {
                    background: "",
                    size: "small",
                    "current-page": _vm.tablePage.currentPage,
                    "page-size": _vm.tablePage.pageSize,
                    total: _vm.tablePage.total,
                    "page-sizes": [
                      10,
                      20,
                      100,
                      1000,
                      { label: "全量数据", value: 1000000 },
                    ],
                    layouts: [
                      "PrevPage",
                      "JumpNumber",
                      "NextPage",
                      "FullJump",
                      "Sizes",
                      "Total",
                    ],
                  },
                  on: { "page-change": _vm.currentChangeHandle },
                }),
              ],
              1
            ),
            _c("user-form", {
              ref: "userForm",
              on: { refreshDataList: _vm.refreshList },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }